import { tv as e } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tai_b48471231fd1734d96945a2b3d8654eb/node_modules/tailwind-variants/dist/index.js";
//#region src/components/ui/tooltip/styles/index.ts
var t = e({
	base: "\n    z-50 px-3 py-1.5 w-fit bg-(--gray-text-2) text-(--gray-bg-1) animate-in fade-in-0 zoom-in-95 rounded-md text-xs text-balance\n    data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95\n    data-[side=bottom]:slide-in-from-top-2\n      data-[side=left]:slide-in-from-right-2\n       data-[side=top]:slide-in-from-bottom-2\n     data-[side=right]:slide-in-from-left-2\n  ",
	slots: { icon: "z-50 size-2.5 bg-(--gray-text-2) fill-(--gray-text-2) translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px]" }
});
//#endregion
export { t as tooltipContentVariants };

//# sourceMappingURL=index.js.map